import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Clock } from 'lucide-react';
import { listBlogArticles } from '../seo/blog-articles';

export function BlogPage() {
  const articles = listBlogArticles();

  return (
    <div className="min-h-screen bg-white">
      <header className="bg-gray-950 pt-28 pb-16 text-white md:pt-32">
        <div className="mx-auto max-w-4xl px-4 text-center sm:px-6">
          <p className="mb-4 text-[10px] font-black uppercase tracking-[0.3em] text-primary-400">
            Blog · Conseils photo & vidéo
          </p>
          <h1 className="text-3xl font-black tracking-tight md:text-5xl">
            Actualités &amp; guides L Benna Production
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-gray-300">
            Conseils mariage, photobooth, production vidéo et impression photo en Tunisie.
          </p>
        </div>
      </header>

      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6">
        {articles.length === 0 ? (
          <p className="text-center text-gray-500">Articles à venir prochainement.</p>
        ) : (
          <ul className="space-y-6">
            {articles.map((article) => (
              <li key={article.slug}>
                <Link
                  to={`/blog/${article.slug}`}
                  className="group block rounded-3xl border border-gray-100 bg-gray-50 p-8 transition hover:border-primary-200 hover:bg-white hover:shadow-lg"
                >
                  <span className="text-[10px] font-black uppercase tracking-widest text-primary-500">
                    {article.badge}
                  </span>
                  <h2 className="mt-2 text-2xl font-black text-gray-950 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h2>
                  <p className="mt-3 text-gray-600 leading-relaxed">{article.description}</p>
                  <div className="mt-4 flex flex-wrap items-center gap-4 text-xs font-bold text-gray-400">
                    <span className="inline-flex items-center gap-1.5">
                      <Calendar className="h-3.5 w-3.5" />
                      {new Date(article.publishedAt).toLocaleDateString('fr-FR', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                      })}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <Clock className="h-3.5 w-3.5" />
                      {article.readingMinutes} min de lecture
                    </span>
                  </div>
                  <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-primary-600">
                    Lire l&apos;article
                    <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" />
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
